import { Box, Button, Flex, Input, Text } from "@chakra-ui/react";
import React from "react";

// Claude: 4-mode filter — Any / Empty / !Empty / Has; added Not Empty mode 17-Apr-2026
const ThreeModeFilter = ({
  label, fieldKey, pendingSearch, setPendingSearch, modes, setModes,
}: {
  label: string; fieldKey: string;
  pendingSearch: Record<string, string>;
  setPendingSearch: React.Dispatch<React.SetStateAction<any>>;
  modes: Record<string, string>;
  setModes: React.Dispatch<React.SetStateAction<any>>;
}) => {
  const mode = modes[fieldKey] || 'any';
  const handleMode = (m: string) => {
    setModes((prev: any) => ({ ...prev, [fieldKey]: m }));
    setPendingSearch((prev: any) => ({
      ...prev,
      [fieldKey]: m === 'empty' ? '__empty__' : m === 'not_empty' ? '__not_empty__' : '',
    }));
  };
  return (
    <Box>
      <Text fontSize="xs" color="gray.500" mb="2px">{label}</Text>
      <Flex gap={1} mb={mode === 'contains' ? 1 : 0}>
        {(['any', 'empty', 'not_empty', 'contains'] as const).map(m => (
          <Button key={m} size="xs" h="18px" fontSize="9px" px={1}
            variant={mode === m ? 'solid' : 'outline'}
            colorScheme={mode === m ? 'purple' : 'gray'}
            onClick={() => handleMode(m)}
          >
            {m === 'any' ? 'Any' : m === 'empty' ? 'Empty' : m === 'not_empty' ? '!Empty' : 'Has'}
          </Button>
        ))}
      </Flex>
      {mode === 'contains' && (
        <Input size="xs" h="26px" fontSize="xs"
          value={pendingSearch[fieldKey] || ''}
          onChange={e => setPendingSearch((prev: any) => ({ ...prev, [fieldKey]: e.target.value }))}
        />
      )}
    </Box>
  );
};

export default ThreeModeFilter;
